import { render, staticRenderFns } from "./paso3.vue?vue&type=template&id=cca05f08&"
import script from "./paso3.vue?vue&type=script&lang=ts&"
export * from "./paso3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports